export const BancosOrcaFascio = [
    { descricao: 'SINAPI', valor: 1 },
    { descricao: 'SBC', valor: 2 },
    { descricao: 'SICRO3', valor: 3 },
    { descricao: 'SIURB', valor: 4 },
    { descricao: 'SIURB INFRA', valor: 5 },
    { descricao: 'FDE', valor: 6 },
    { descricao: 'CPOS', valor: 7 },
    { descricao: 'EMOP', valor: 8 },
    { descricao: 'SCO', valor: 9 },
    { descricao: 'SETOP', valor: 10 },
    { descricao: 'SUDECAP', valor: 11 },
    { descricao: 'IOPES', valor: 12 },
    { descricao: 'ORSE', valor: 13 },
    { descricao: 'SEINFRA', valor: 14 },
    { descricao: 'CAEMA', valor: 15 },
    { descricao: 'COMPESA', valor: 16 },
    { descricao: 'AGESUL', valor: 17 },
    { descricao: 'AGETOP CIVIL', valor: 18 },
    { descricao: 'AGETOP RODOVIARIA', valor: 19 },
    { descricao: 'SEDOP', valor: 20 },
    { descricao: 'DERPR', valor: 21 }
]

export const EncargosSociaisOrcaFascio = [
    { descricao: 'Onerado', valor: 1 },
    { descricao: 'Desonerado', valor: 2 }
]

export const TiposContrato = [
    { descricao: 'Aquisição',              valor: 'Aquisição',              temBDI: false },
    { descricao: 'Fiscal Externo',         valor: 'Fiscal Externo',         temBDI: false },
    { descricao: 'Projeto',                valor: 'Projeto',                temBDI: false },
    { descricao: 'Outras Contratações',    valor: 'Outras Contratações',    temBDI: false },
    { descricao: 'Obras',                  valor: 'Obras',                  temBDI: true  },
    { descricao: 'Serviços de Engenharia', valor: 'Serviços de Engenharia', temBDI: true  },
]

export const TIPOS_COM_BDI = ['Obras', 'Serviços de Engenharia']
